import { Ghost } from "lucide-react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0f172a] to-[#1e3a8a] flex flex-col items-center justify-center text-center px-6">
      <Ghost className="text-white mb-4" size={64} />
      <h1 className="text-4xl sm:text-5xl font-bold text-white mb-2">404</h1>
      <p className="text-lg text-gray-300 mb-6">
        Oops! The page you're looking for doesn't exist.
      </p>
      <Link
        to="/"
        className="bg-white text-blue-800 font-semibold py-2 px-6 rounded-lg transition hover:bg-blue-100"
      >
        Go Home
      </Link>
    </div>
  );
}
